import * as React from 'react';
import { Create } from 'react-admin';
import { WorkerForm } from './commons';
import { transformRecord } from './utils';

const WorkerCreate = () => (
    <Create transform={transformRecord} redirect="list">
        <WorkerForm passwordRequired/>
    </Create >
);

export default WorkerCreate;
